module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back004.1971f86c.webp";